import { FlowHeaderButtons } from "src/flowContainer/FlowHeaderButtons";
import { RevisionHeaderButtons } from "src/flowContainer/RevisionHeader/RevisionHeaderButtons";
import { LastUpdatedInfo } from "src/flowContainer/versionEditedInfo/LastUpdateInfo";
import { useCapabilities } from "src/hooks/useCapabilities";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { LastSimulatedInfo } from "src/simulations/LastSimulatedInfo";

export const VersionAuthoringHeaderRightSideContent: React.FC = () => {
  const { version, isRevision, simulationId, flow } = useAuthoringContext();
  const { flowVersions } = useCapabilities();

  let content;
  if (isRevision) {
    content = <RevisionHeaderButtons />;
  } else if (simulationId) {
    content = (
      <div className="flex flex-row items-center gap-x-2">
        <LastSimulatedInfo
          flowId={flow.id}
          flowVersion={version}
          simulationId={simulationId}
        />
        <FlowHeaderButtons />
      </div>
    );
  } else {
    content = (
      <div className="flex flex-row items-center gap-x-2">
        {flowVersions.canEdit && <LastUpdatedInfo flowVersion={version} />}
        <FlowHeaderButtons />
      </div>
    );
  }

  return <div className="flex items-center gap-x-2">{content}</div>;
};
